export class RuleOutcomeList {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "outcomes",
            "baseName": "outcomes",
            "type": "Array<RuleOutcome>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RuleOutcomeList.attributeTypeMap;
    }
    constructor() {
    }
}
